import { render, staticRenderFns } from "./AssignmentMailContent.vue?vue&type=template&id=b13efb0a"
import script from "./AssignmentMailContent.vue?vue&type=script&lang=js"
export * from "./AssignmentMailContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports